import { pages } from "../siteContent";
import { normalizePath } from "../utils/routing";

const CLIENT_ROUTES = new Set(Object.keys(pages));

export function NavLink({ to, children, className = "", onNavigate, onClose, ariaCurrent }) {
  return (
    <a
      href={to}
      className={className}
      aria-current={ariaCurrent}
      onClick={(event) => {
        if (CLIENT_ROUTES.has(normalizePath(to))) {
          event.preventDefault();
          onNavigate(to);
          if (onClose) {
            onClose();
          }
        }
      }}
    >
      {children}
    </a>
  );
}
